import * as peersActionTypes from "../../../actions/peers/peersActionTypes";
import * as persistenceActionTypes from "../../../actions/persistence/persistenceActionTypes";

export const INIT_STATE = {
  group: { loading: false },
  exposure: { loading: false },
};

const peerPricingReducer = (state, action) => {
  if (state === undefined) {
    state = INIT_STATE;
  }

  switch (action.type) {
    case persistenceActionTypes.LOAD_SUBMISSION_STARTED:
      return {
        ...INIT_STATE,
      };
    case peersActionTypes.LOAD_PEER:
      return {
        ...state,
        peerData: {
          ...(state.peerData || {}),
          [action.payload.filename]: action.payload.state,
        },
      };
    case peersActionTypes.ADD_PEER:
      return {
        ...state,
        peerData: {
          ...(state.peerData || {}),
          [action.payload.filename]: undefined,
        },
      };
    case peersActionTypes.DELETE_PEER:
      return {
        ...state,
        peerData: {
          ...(state.peerData || {}),
          [action.payload]: undefined,
        },
      };
    case peersActionTypes.REPLACE_PEER_SUBMISSIONS:
      return {
        ...state,
        peerData: {},
      };
    default:
      return state;
  }
};

export default peerPricingReducer;
